import React, { createContext, useContext, useMemo } from "react";
import { customerConfig as defaultCustomerConfig } from "../../custom/customer.config.js";

const ConfigContext = createContext(defaultCustomerConfig);

export function ConfigProvider({ config = defaultCustomerConfig, children }) {
  const mergedConfig = useMemo(() => {
    return {
      ...defaultCustomerConfig,
      ...config,
      branding: {
        ...defaultCustomerConfig.branding,
        ...(config?.branding || {})
      },
      features: {
        ...defaultCustomerConfig.features,
        ...(config?.features || {})
      },
      businessDefaults: {
        ...defaultCustomerConfig.businessDefaults,
        ...(config?.businessDefaults || {})
      },
      auth: {
        ...defaultCustomerConfig.auth,
        ...(config?.auth || {})
      }
    };
  }, [config]);

  return (
    <ConfigContext.Provider value={mergedConfig}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig() {
  const context = useContext(ConfigContext);
  if (!context) {
    return defaultCustomerConfig;
  }
  return context;
}

export default ConfigContext;
